'use client';
import React, { useEffect, useState, type JSX } from 'react';
import { CategoryTab, CategoryTabs, CategoryTabsContainer, TabBarContainer } from './styles';
import { Row } from '../../styles';
import { Box, BoxProps } from '@mui/material';
import { useBreakpoint } from '../../hooks';

type TabsProps = BoxProps & {
    tabHeadlines: string[];
    tabContents: JSX.Element[];
    preopenedTab?: number;
    justifyStart?: boolean;
    onSwitchTab?: (index: number) => void;
    wrapTabs?: boolean;
};

export const TabBar = ({
    preopenedTab,
    tabHeadlines,
    tabContents,
    justifyStart = false,
    onSwitchTab,
    wrapTabs,
    ...props
}: TabsProps) => {
    const [activeTab, setActiveTab] = useState(preopenedTab ?? 0);
    const breakpoint = useBreakpoint();
    const onSwitch = (_event: React.SyntheticEvent<Element, Event>, index: number) => {
        setActiveTab(index);
        onSwitchTab?.(index);
    };

    useEffect(() => {
        if (preopenedTab !== undefined) {
            setActiveTab(preopenedTab);
        }
    }, [preopenedTab]);

    return (
        <TabBarContainer {...props}>
            {tabContents.length > 1 && (
                <Row gap={1}>
                    <CategoryTabsContainer>
                        <CategoryTabs
                            wrapTabs={wrapTabs}
                            value={activeTab}
                            variant='scrollable'
                            scrollButtons
                            onChange={onSwitch}
                            justifyStart={justifyStart}
                        >
                            {tabHeadlines.map((text, index) => (
                                <CategoryTab
                                    breakpoint={breakpoint}
                                    tabIndex={0}
                                    key={index}
                                    value={index}
                                    label={text}
                                />
                            ))}
                        </CategoryTabs>
                    </CategoryTabsContainer>
                </Row>
            )}
            <Box>{tabContents[activeTab]}</Box>
        </TabBarContainer>
    );
};
